export const changeTab = (state: { dataCrl: { configTabs: { tabInView: any; }; }; }, action: { payload: any; }) => {
  state.dataCrl.configTabs.tabInView = action.payload;
};
